import { motion } from 'framer-motion'
import { Layers } from 'lucide-react'
import { PageHeader, fadeUp } from '@personic/shared'
import { buildBreadcrumbs } from '@/config/routes'
import { useCalibration } from '@/hooks/useCalibration'

export default function Presets() {
  const { isLoading } = useCalibration()
  const breadcrumbs = buildBreadcrumbs('/settings/calibration/presets')

  return (
    <div>
      <PageHeader
        title="Calibration Presets"
        description="Manage preset calibration configurations for different use cases."
        breadcrumbs={breadcrumbs}
      />

      <motion.div variants={fadeUp} initial="hidden" animate="visible" className="max-w-4xl">
        <div className="rounded-xl border border-warm-200 bg-white p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-copper-50 flex items-center justify-center">
              <Layers className="w-5 h-5 text-copper-500" />
            </div>
            <h2 className="font-heading font-semibold text-midnight-800">Presets</h2>
          </div>
          {isLoading ? (
            <div className="animate-pulse space-y-3">
              {[1, 2, 3].map(i => (
                <div key={i} className="h-16 bg-warm-100 rounded" />
              ))}
            </div>
          ) : (
            <p className="text-sm text-warm-500 text-center py-6">
              Calibration presets allow you to save and apply different configurations for specific scenarios (e.g., sales, support, research).
            </p>
          )}
        </div>
      </motion.div>
    </div>
  )
}
